import { Component } from '@angular/core';

@Component({
  selector: 'cil-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {}
